module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/profile/profile-f-d17874a32f5a27dbd3c40b7456838426.png";